<ul class="sidebar-menu" *ngIf="show_menu">
  <ng-container *ngIf="user_type == 'coach'; else athletic_panel">
    <li>
      <a
        routerLink="/sport"
        routerLinkActive="active-link"
        matTooltip="Sport"
        matTooltipPosition="right"
      >
        <span class="nav-title">Sports</span>
        <span
          ><img
            src="assets/images/sport.svg"
            alt=""
            style="height: 40px; width: 40px"
        /></span>
      </a>
    </li>
    <ng-container *ngIf="sport_level">
      <li>
        <a
          routerLink="/dashboard"
          routerLinkActive="active-link"
          matTooltip="Dashboard"
          matTooltipPosition="right"
        >
          <span class="nav-title">Dashboard</span>
          <span><img src="assets/images/dashboard.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/availability"
          routerLinkActive="active-link"
          matTooltip="Availability"
          matTooltipPosition="right"
        >
          <span class="nav-title">Availability</span>
          <span><img src="assets/images/schedule.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/tournaments"
          routerLinkActive="active-link"
          matTooltip="Tournaments"
          matTooltipPosition="right"
        >
          <span class="nav-title">Tournaments</span>
          <span><img src="assets/images/tournament.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/requests"
          routerLinkActive="active-link"
          matTooltip="Requests"
          matTooltipPosition="right"
        >
          <span class="nav-title">Requests</span>
          <span><img src="assets/images/request.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/calender"
          routerLinkActive="active-link"
          matTooltip="Calendar"
          matTooltipPosition="right"
        >
          <span class="nav-title">Calendar</span>
          <span><img src="assets/images/calender.svg" alt="" /></span>
        </a>
      </li>
    </ng-container>
  </ng-container>
  <ng-template #athletic_panel>
    <li>
      <a
        routerLink="/athletic-director/dashboard"
        routerLinkActive="active-link"
        matTooltip="Dashboard"
        matTooltipPosition="right"
      >
        <span class="nav-title">Dashboard</span>
        <span><img src="assets/images/dashboard.svg" alt="" /></span>
      </a>
    </li>
    <ng-container *ngIf="sport_level">
      <li>
        <a
          routerLink="/athletic-director/availability"
          routerLinkActive="active-link"
          matTooltip="Availability"
          matTooltipPosition="right"
        >
          <span class="nav-title">Availability</span>
          <span><img src="assets/images/schedule.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/tournaments/athletic-director/"
          routerLinkActive="active-link"
          matTooltip="Tournaments"
          matTooltipPosition="right"
        >
          <span class="nav-title">Tournaments</span>
          <span><img src="assets/images/tournament.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/athletic-director/requests"
          routerLinkActive="active-link"
          matTooltip="Requests"
          matTooltipPosition="right"
        >
          <span class="nav-title">Requests</span>
          <span><img src="assets/images/request.svg" alt="" /></span>
        </a>
      </li>
      <li>
        <a
          routerLink="/athletic-director/calender"
          routerLinkActive="active-link"
          matTooltip="Calendar"
          matTooltipPosition="right"
        >
          <span class="nav-title">Calendar</span>
          <span><img src="assets/images/calender.svg" alt="" /></span>
        </a>
      </li>
    </ng-container>
  </ng-template>
  <li>
    <a
      routerLink="/tutorials"
      routerLinkActive="active-link"
      matTooltip="Tutorials"
      matTooltipPosition="right"
    >
      <span class="nav-title">Tutorials</span>
      <span><img src="assets/images/tutorial.svg" alt="" /></span>
    </a>
  </li>
</ul>

<ul class="sidebar-footer">
  <li *ngIf="show_menu && user_type == 'coach'">
    <a
      routerLink="/email"
      routerLinkActive="active-link"
      matTooltip="Invite"
      matTooltipPosition="right"
    >
      <span class="nav-title">Invite</span>
      <span><img src="assets/images/invite.svg" alt="" /></span>
    </a>
  </li>
  <li>
    <a
      routerLink="/settings"
      routerLinkActive="active-link"
      matTooltip="Settings"
      matTooltipPosition="right"
    >
      <span class="nav-title">Settings</span>
      <span><img src="assets/images/settings.svg" alt="" /></span>
    </a>
  </li>
  <li>
    <a
      href="javascript:;"
      (click)="logout()"
      matTooltip="Logout"
      matTooltipPosition="right"
    >
      <span><img src="assets/images/logout.svg" alt="" /></span>
      <span class="nav-title">Logout</span>
    </a>
  </li>
</ul>
